@if (loadingService.loading$ | async; as isLoading) {
  @if (isLoading) {
    <div class="loading-overlay">
      <mat-spinner></mat-spinner>
    </div>
  }
}
<router-outlet></router-outlet>
